import React from "react";
import classNames from "classnames/bind";
import styles from "./HeroSection.module.scss";
import Button from "../Button/Button";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const cx = classNames.bind(styles);

export default function HeroSection({ id, data }) {
  const innerStyle = {
    backgroundImage: `url(${data?.section1?.backgroundImageUrl})`,
  };

  return (
    <div id={id} {...useScrollFadeIn("up", 1, 0.3)} className={cx("container")}>
      <div className={cx("inner")} style={innerStyle}>
        <div className={cx("logo-box")}>
          <img
            className={cx("logo")}
            src="/images/hero-logo.png"
            alt="hero-section-logo"
          />
          <div className={cx("content-box")}>
            <div className={cx("title-box")}>
              <p className={cx("title")}>
                {data?.section1?.title}
                <b className={cx("title-b")}>.</b>
              </p>
            </div>
            <p className={`${cx("text")} font-play`}>
              {data?.section1?.description}
            </p>
          </div>
          <Button data={data} />
        </div>
        {/* <img
          className={cx("bg-img")}
          src={data?.section1?.backgroundImageUrl}
          alt={data?.section1?.backgroundImageUrl}
        /> */}
      </div>
    </div>
  );
}
